import { combineReducers } from '@reduxjs/toolkit';
import { gameInfoSlice } from 'modules/overlay-v2/store/game-info/game-info';
import { overlaySlice } from './overlay/overlay';
import { timeSlice } from './time/time';

const overlayV2Reducer = combineReducers({
  overlay: overlaySlice.reducer,
  gameInfo: gameInfoSlice.reducer,
  time: timeSlice.reducer,
});

export default overlayV2Reducer;
